type Props = {
  className?: string;
};

const AddIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="48"
    width="48"
    className={className}
  >
    <path d="M21.75 38.75V26.3H9.25V21.75H21.75V9.25H26.3V21.75H38.8V26.3H26.3V38.75Z" />
  </svg>
);

export default AddIcon;
